import React, { useState, useEffect, useMemo, useCallback } from 'react'
import B2BLayout from '../../../../layouts/b2b'
import { Button, Table } from 'antd'
import { getColumns } from './columns'
import fetchAPI from '../../../../../lib/utils/fetch-api'
import { useLocation, useNavigate } from 'react-router-dom'
import { MapTitle } from '../../../appeals/card/styles'
import { PlusOutlined } from '@ant-design/icons'
import { TablePaginationConfig } from 'antd/es/table'
import { Sorter } from '../../../../interfaces'
import { objectToUrl } from '../../../utils'
import { DataType } from './interface'

const HRPaymentsList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [data, setData] = useState<DataType[]>([])
  const [loading, setLoading] = useState(false)
  const [sorter, setSorter] = useState<Sorter>({})
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    total: 10,
    position: ['bottomCenter'],
    showSizeChanger: false,
  })

  /**
   * Хлебные крошки
   */
  const breadcrumbs = useMemo(
    () => [
      {
        href: '/admin',
        title: 'Админка',
      },
      {
        href: '/hr/dashboard',
        title: 'Дашборд',
      },
      {
        title: 'Оплаты',
      },
    ],
    [],
  )

  /**
   * Обновляет состояние пагинации
   */
  const updatePagination = useCallback(newState => {
    setPagination(current => ({
      ...current,
      ...newState,
    }))
  }, [])

  /**
   * Получает записи
   */
  const getData = useCallback(async () => {
    try {
      setLoading(true)
      const currentUrlParams = Object.fromEntries(new URLSearchParams(location.search))
      const result = await fetchAPI(`/api/hr/payments${objectToUrl(currentUrlParams)}`)
      if (result.data) {
        setData(result.data)
      }
      if (result.pagination) {
        updatePagination(result.pagination)
      }
      if (result.sorter) {
        setSorter(result.sorter)
      }
    } catch (error) {
      console.error('Ошибка при получении данных:', error)
    } finally {
      setLoading(false)
    }
  }, [location.search, updatePagination])

  useEffect(() => {
    getData()
  }, [getData])

  /**
   * Отслеживает изменение состояния таблицы
   *
   * @param pagination
   * @param _filters
   * @param sorter
   */
  const handleTableChange = (pagination, _filters, sorter) => {
    const currentUrlParams = Object.fromEntries(new URLSearchParams(location.search))
    const current = {
      ...currentUrlParams,
      sort_order: sorter?.order,
      sort_field: sorter?.field,
      page: pagination.current,
    }
    if (current?.page === 1) {
      delete current.page
    }
    if (current?.sort_order === undefined) {
      delete current.sort_order
      delete current.sort_field
    }
    const urlParams = new URLSearchParams(current).toString()
    navigate({ search: urlParams })
  }

  const handleCreate = () => {
    navigate(`/hr/payments/new`)
  }

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <MapTitle>Оплаты</MapTitle>
        <Button onClick={handleCreate}>
          <PlusOutlined /> Добавить оплату
        </Button>
      </div>
      <Table
        showSorterTooltip={{ overlay: 'Нажмите для сортировки', placement: 'bottom' }}
        columns={getColumns(sorter, navigate, getData)}
        rowKey={r => r?.id}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        scroll={{
          x: 'max-content',
          y: '72vh',
        }}
        size="small"
      />
    </B2BLayout>
  )
}

export default HRPaymentsList
